export default __webpack_public_path__ + "static/media/Milteny-95x69.efd40050.jpg";